const _ = require("lodash");

// สร้าง formatter ครั้งเดียว — การ new Intl.NumberFormat() ทุกครั้งที่เรียก
// เป็นคอขวดในหน้าที่มีหลายพันแถว (รายงานภาษีขาย ฯลฯ)
const numberFormat = new Intl.NumberFormat();

export default function formatTwoDecimal(val) {
  if (val) {
    let formatFloat = numberFormat.format(parseFloat((val / 100).toFixed(2)))
    let split = formatFloat.split('.')
    let number = split[0]
    let decimal = split[1]
    let result = [number]
    result.push(_.padEnd(decimal, 2, '0'))
    return result.join('.')
  }
  return "0.00"
}
